var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "27px",
    viewBox: "0 0 28 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 70\u5907\u4EFD 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9,
    transform: "translate(-324.000000, -720.000000)",
    stroke: "#828E9A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(0.000000, 714.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-81",
    transform: "translate(17.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-80",
    transform: "translate(306.000000, 0.292653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-79",
    transform: "translate(3.961972, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.71922,3.09639289 L14.7876514,5.02796156 C14.127013,5.68859995 14.127013,6.75970642 14.7876514,7.42034482 C15.4482898,8.08098321 16.5193962,8.08098321 17.1800346,7.42034482 L19.3874022,5.21297722 L19.3874022,5.21297722 C20.5513996,6.37697455 20.5513996,8.26418711 19.3874022,9.42818445 L17.1827028,11.6328839 C16.1910084,12.6245783 14.5831541,12.6245783 13.5914597,11.6328839 L13.5914597,11.6328839 L13.5914597,11.6328839 L4.85212185,20.3722218 C3.95887088,21.2654727 2.51062491,21.2654727 1.61737395,20.3722218 C0.724122982,19.4789708 0.724122982,18.0307248 1.61737395,17.1374739 L10.1383114,8.61653645 L10.1383114,8.61653645 C8.82429603,7.3025211 8.82429603,5.17208128 10.1383114,3.85806593 C10.142682,3.85369535 10.1470646,3.84933682 10.1514592,3.84499039 L11.1273863,2.87976092 C12.6320477,1.39159289 15.0582153,1.4049634 16.5463833,2.90962479 C16.6060474,2.96995015 16.6636914,3.03224052 16.71922,3.09639289 L16.71922,3.09639289 L16.71922,3.09639289 Z",
    id: "\\u8DEF\\u5F84-117",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25740763,4.41646937 L5.34523283,2.76508382 C4.94916196,2.42303052 4.35635292,2.44420028 3.98568993,2.81363436 L1.75933448,5.03260846 C1.36816227,5.42248376 1.36711092,6.05564787 1.75698622,6.44682007 C1.77056775,6.46044678 1.7845397,6.47367871 1.79888463,6.48649933 L5.71436978,9.98592092 L5.71436978,9.98592092",
    id: "\\u8DEF\\u5F84-118",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2146928,16.7596247 L15.9139331,20.5973032 C16.2972196,20.9949335 16.9302778,21.0065615 17.3279082,20.6232751 C17.330203,20.6210631 17.3324871,20.6188401 17.3347606,20.6166063 L19.9404018,18.0564465 C20.3343491,17.6693755 20.3399235,17.0362351 19.9528525,16.6422878 C19.9411514,16.6303789 19.929154,16.6187649 19.9168714,16.6074567 L17.2514392,14.1534714 L17.2514392,14.1534714",
    id: "\\u8DEF\\u5F84-119",
    strokeWidth: 1.5
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/manager.e97e921e1a75ac62c73380d648e06e71.svg";
export { ForwardRef as ReactComponent };